exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-subsc-contents[data-v-75dc77c4]{padding:60px 20px}.block-subsc-contents ol[data-v-75dc77c4]{list-style:none;padding:0;margin:0;counter-reset:item}.block-subsc-contents ol li .img1[data-v-75dc77c4],.block-subsc-contents ol li .img2[data-v-75dc77c4]{width:100%;margin:8px auto 0}.block-subsc-contents ol li+li[data-v-75dc77c4]{margin:23px 0 0}.block-subsc-contents ol h3[data-v-75dc77c4]{font-weight:700;font-size:20px;line-height:24px;margin:0 0 8px;-webkit-font-feature-settings:\"palt\";font-feature-settings:\"palt\";letter-spacing:.7px}.block-subsc-contents ol h3>img[data-v-75dc77c4]{display:inline;vertical-align:-9px;margin:0 2px 0 0}.block-subsc-contents img[data-v-75dc77c4]{display:block;max-width:100%;margin:8px 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75dc77c4","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/blocks/BlockSubscContents.vue
// module id = uRfP
// module chunks = 0